// src/pages/hotelRatings/EditHotelRating.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelRating from "../../components/hotelRatings/FormAddEditHotelRating";
import useGetHotelRating from "../../hooks/hotelRatings/useGetHotelRating";
import { CircularProgress, Box } from "@mui/material";

const EditHotelRating = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, hotelRating } = useGetHotelRating(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelRating
                isEdit={true}
                currentData={hotelRating}
                onSubmitSuccess={() => navigate("/hotel-ratings")}
            />
        </WrapperSection>
    );
};

export default EditHotelRating;
